/* eslint-disable import/prefer-default-export */
import Vue from 'vue'
import {
	vendorApis
} from '../services/ApiServices/vendorApis'

export const vendorCommon = new Vue({
	methods: {
		async imageUploader (event) {
			let imageUrl = ''
			const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i
			if (!allowedExtensions.exec(event.target.value)) {
				this.$toasted.show('Images of non specified type cannot be uploaded.')
			} else {
				const formData = new FormData()
				formData.append('document', event.target.files[0])
				await vendorApis.serverImageUpload(formData)
					.then((res) => {
						imageUrl = res.bodyText
						// this.account.cancelled_check = res.bodyText;
					})
					.catch((e) => {
						if (e.status === 413) {
							Vue.toasted.show('File Uploaded is too Large', { theme: 'toasted-primary',
								position: 'top-center' })
						} else {
							Vue.toasted.show('Error occurred while Updating Photo')
						}
					})
			}
			return imageUrl
		}
	}
})
